import SpindlClient from './SpindlClient';

function createSpindlClient() {
  const spindl = new SpindlClient();
  return spindl;
}

export default createSpindlClient();
